import React, { useState, useEffect } from 'react';
import { FaSync, FaUserPlus, FaUserMinus, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import '../../../style/emp_descuentos.css';
import apiServices from '../../../actions/services';
import ParmaLogo from '../../../utils/logo';

const DescuentoEmpledos = () => {
  // Estados
  const { user } = useSelector(state => state.auth);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    CodigoAlternativo: '',
    CARDCODE:'',
    NIT: '',
    Nombre: '',
    Lista_Precios_SAP: '',
    ESTADO: ''
  });
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [processingItem, setProcessingItem] = useState(null);

  // Función para obtener datos de la API
  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiServices.get('DescuentoEmpleadosSalas', '', user);
      console.log('Respuesta completa:', response);
      
      // Verificar si la respuesta tiene la estructura esperada
      if (response && response.datos_Generados) {
        try {
          // Parsear la cadena JSON que está en datos_Generados
          const parsedData = JSON.parse(response.datos_Generados);
          console.log('Datos parseados:', parsedData);
          
          // Asegurarnos de que siempre trabajamos con an array
          if (Array.isArray(parsedData)) {
            setData(parsedData);
          } else {
            throw new Error('Los datos parseados no son un array');
          }
        } catch (parseError) {
          console.error('Error al parsear datos_Generados:', parseError);
          throw new Error('Formato de datos inválido en la respuesta');
        }
      } else {
        throw new Error('La respuesta no contiene datos_Generados');
      }
    } catch (err) {
      setError('Error al obtener los datos: ' + (err.message || 'Error desconocido'));
      console.error('Error fetching data:', err);
      setData([]); // Asegurar que data siempre sea un array
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Función para determinar si es BAJA o ALTA
  const getAccionTipo = (item) => {
    const listaPrecios = item.Lista_Precios_SAP || '';
    
    if (listaPrecios.includes('Socios') || listaPrecios.includes('Empleados')) {
      return { tipo: 'BAJA', color: '#dc3545', icon: <FaUserMinus /> };
    } else {
      return { tipo: 'ALTA', color: '#28a745', icon: <FaUserPlus /> };
    }
  };

  // Función para determinar el estado de la fila según Lista_Precios_SAP
  const getEstadoFila = (item) => {
    const listaPrecios = item.Lista_Precios_SAP || '';
    
    if (listaPrecios.includes('Salas')) {
      return { 
        estado: 'warning', 
        color: '#ffc107', 
        icon: <FaExclamationTriangle />, 
        texto: 'Contiene Salas' 
      };
    } else if (listaPrecios.includes('Socio')) {
      return { 
        estado: 'info', 
        color: '#17a2b8', 
        icon: <FaInfoCircle />, 
        texto: 'Contiene Socio' 
      };
    } else {
      return { 
        estado: 'normal', 
        color: '', 
        icon: null, 
        texto: '' 
      };
    }
  };

  const enviarRegistro = async (item, index, accionTipo) => {
    setProcessingItem(item);
    setShowLoadingModal(true);
    const startTime = Date.now();
    const minLoadingTime = 5000;
    try {
      const datosenviar = {
        Tipo: accionTipo, 
        Nit: item.NIT, 
        CodigoEvolution: item.CodigoEvolution, 
        Nombre: item.Nombre,
        CardCode: item.CARDCODE
      };
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(0, minLoadingTime - elapsedTime);
      const result = await apiServices.post('CrearEmpleadoConDescuento', datosenviar, user);
      if (remainingTime > 0) {
        await new Promise(resolve => setTimeout(resolve, remainingTime));
      }
      setShowLoadingModal(false);
      await new Promise(resolve => setTimeout(resolve, 100));
      fetchData();
    } catch (err) {
      console.error('Error al enviar registro:', err);
      setShowLoadingModal(false);
      await new Promise(resolve => setTimeout(resolve, 100));
    } finally {
      setShowLoadingModal(false);
      setProcessingItem(null);
    }
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };
  const filteredData = Array.isArray(data) 
    ? data.filter(item => {
        return Object.keys(filters).every(key => {
          if (filters[key] === '') return true;
          return item && item[key] && item[key].toString().toLowerCase().includes(filters[key].toLowerCase());
        });
      })
    : [];

  return (
    <div className="container">
      {showLoadingModal && (
        <div className="loading-modal">
          <div className="loading-content">
            <div className="pulsing-logo">
              <ParmaLogo width={150} height={100} />
            </div>
            <div className="loading-text">
              <p>Procesando registro de {processingItem?.Nombre}</p>
              <p>Por favor espere...</p>
            </div>
          </div>
        </div>
      )}

      <h1>Gestión de Empleados</h1>
      <div className="update-section">
        <button 
          onClick={fetchData} 
          disabled={loading}
          className="update-button"
        >
          <FaSync className={loading ? 'spinning' : ''} /> 
          {loading ? 'Cargando...' : 'Actualizar Datos'}
        </button>
        
        {error && <div className="error-message">{error}</div>}
      </div>
      <div className="filters-section">
        <h2>Filtros</h2>
        <div className="filters-grid">
          {Object.keys(filters).map(key => (
            <div key={key} className="filter-item">
              <label htmlFor={key}>{key.replace(/_/g, ' ')}:</label>
              <input
                type="text"
                id={key}
                name={key}
                value={filters[key]}
                onChange={handleFilterChange}
                placeholder={`Filtrar por ${key}`}
                disabled={loading}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="table-section">
        <h2>Resultados ({filteredData.length} registros)</h2>
        
        {loading ? (
          <div className="loading-message">Cargando datos...</div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : filteredData.length === 0 ? (
          <div className="no-data-message">
            {data.length === 0 ? 'No hay datos disponibles' : 'No se encontraron resultados con los filtros aplicados'}
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th></th>
                <th>Estado</th>
                <th>Código Alternativo</th>
                <th>Código SAP</th>
                <th>NIT</th>
                <th>Nombre</th>
                <th>Lista Precios SAP</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => {
                const accionTipo = getAccionTipo(item);
                const estadoFila = getEstadoFila(item);
                
                return (
                  <tr key={index} className={`fila-${estadoFila.estado}`}>
                    <td className="estado-cell" title={estadoFila.texto}>
                      {estadoFila.icon}
                    </td>
                    <td>{item.ESTADO}</td>
                    <td>{item.CodigoAlternativo || 'N/A'}</td>
                    <td>{item.CARDCODE || 'N/A'}</td>
                    <td>{item.NIT || 'N/A'}</td>
                    <td>{item.Nombre || 'N/A'}</td>
                    <td>{item.Lista_Precios_SAP || 'N/A'}</td>
                    <td className="action-cell">
                      <button 
                        onClick={() => enviarRegistro(item, index, accionTipo.tipo)}
                        disabled={showLoadingModal}
                        className="action-button"
                        style={{ backgroundColor: accionTipo.color }}
                        title={accionTipo.tipo === 'BAJA' ? 'Dar de baja empleado' : 'Dar de alta empleado'}
                      >
                        {accionTipo.icon}
                        {accionTipo.tipo}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default DescuentoEmpledos;